import { ApiResponse } from 'apisauce';
import {
  GlobalSearchProductCodeParams,
  SearchResultGroup,
} from '../../../modules/global-search/globalSearch.types';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';

const PATH = '/global-search/product-code';

export const findGlobalSearchProductCode = (
  params: GlobalSearchProductCodeParams,
  signal?: AbortSignal,
): Promise<ApiResponse<SearchResultGroup>> =>
  restApi.get<SearchResultGroup>(
    PATH,
    { q: params.q },
    { cancelToken: cancelTokenFromSignal(signal)?.token },
  );
